import { loadDimensions } from "@/services/dimension/dimension.service"
import { getProjectCases } from "@/services/project/cases.service"
import { getProjectPropertySets } from "@/services/project/project"
import { getProjectSimulations } from "@/services/project/simulation.service"
import { getActiveUnitSet } from "@/services/unitSet/unitSet.service"
import { createAsyncThunk } from "@reduxjs/toolkit"


export const getProjectCasesThunk = createAsyncThunk('project/getProjectCasesThunk', async (params: {pId: number}) => {
  return await getProjectCases(params)
})

export const getProjectPropertySetsThunk = createAsyncThunk('project/getProjectPropertySetsThunk', async (params: {pId: number}) => {
  return await getProjectPropertySets(params)
})
export const getProjectSimulationsThunk = createAsyncThunk('project/getProjectSimulationsThunk', async (fsId: number) => {
  return await getProjectSimulations({fsId})
})
export const getActiveUnitSetThunk = createAsyncThunk('project/getActiveUnitSetThunk', async (params: {projectId: number}) => {
  return await getActiveUnitSet(params)
})

export const loadDimensionsThunk = createAsyncThunk('project/loadDimensionsThunk', async () => {
  return await loadDimensions()
})